//#region src/bite_log_moneris_event.ts
let BiteLogMonerisEvent = /* @__PURE__ */ function(BiteLogMonerisEvent) {
	BiteLogMonerisEvent[BiteLogMonerisEvent["None"] = 0] = "None";
	BiteLogMonerisEvent[BiteLogMonerisEvent["TerminalConnected"] = 1] = "TerminalConnected";
	BiteLogMonerisEvent[BiteLogMonerisEvent["TerminalDisconnected"] = 2] = "TerminalDisconnected";
	BiteLogMonerisEvent[BiteLogMonerisEvent["SaleTransactionRequested"] = 3] = "SaleTransactionRequested";
	BiteLogMonerisEvent[BiteLogMonerisEvent["SaleTransaction"] = 4] = "SaleTransaction";
	BiteLogMonerisEvent[BiteLogMonerisEvent["SaleTransactionError"] = 5] = "SaleTransactionError";
	BiteLogMonerisEvent[BiteLogMonerisEvent["DeviceSetup"] = 6] = "DeviceSetup";
	BiteLogMonerisEvent[BiteLogMonerisEvent["DeviceSetupError"] = 7] = "DeviceSetupError";
	BiteLogMonerisEvent[BiteLogMonerisEvent["RefundTransactionRequested"] = 8] = "RefundTransactionRequested";
	BiteLogMonerisEvent[BiteLogMonerisEvent["RefundTransaction"] = 9] = "RefundTransaction";
	BiteLogMonerisEvent[BiteLogMonerisEvent["RefundTransactionError"] = 10] = "RefundTransactionError";
	BiteLogMonerisEvent[BiteLogMonerisEvent["Logs"] = 11] = "Logs";
	BiteLogMonerisEvent[BiteLogMonerisEvent["TerminalUnresponsiveError"] = 12] = "TerminalUnresponsiveError";
	BiteLogMonerisEvent[BiteLogMonerisEvent["TerminalRebootRequested"] = 13] = "TerminalRebootRequested";
	BiteLogMonerisEvent[BiteLogMonerisEvent["TerminalRebootSkipped"] = 14] = "TerminalRebootSkipped";
	return BiteLogMonerisEvent;
}({});
//#endregion
export { BiteLogMonerisEvent };

//# sourceMappingURL=bite_log_moneris_event.js.map